import {BaseModel} from "../base.model";
export interface OnlineClassification extends BaseModel {
    name?: any;//分类名称
    parentId?: any
    level?: any
    pathIds?: any
}

export const defaultOnlineClassification: Readonly<OnlineClassification> = {};